










































import { Component, Vue, Prop } from "vue-property-decorator"

import { MColumn } from "@/api/modules/column"
@Component({
  name: "GameSearchList",
  components: {
    Empty: () => import("@/components/empty/empty.vue"),
    LoadMore: () => import("@/components/loadMore/loadMore.vue")
  }
})
export default class GameSearchList extends Vue {
  @Prop({ type: Object, default: "" }) item: MColumn.IColumnGameItem

  get filterTags() {
    return this.$root.$tstore.modules.gameList.getters.filterTags
  }

  get new_tag_style() {
    return this.filterTags && this.filterTags.length > 0
      ? this.item.new_tag_style.filter(v => !this.filterTags.includes(v.name))
      : this.item.new_tag_style
  }
}
